/**
 * Helmet for Collection
 */

import tr from '../../../locales';
import { getResponsiveAssets } from '../../../utils/image';
import { getOriginLocation } from '../../../utils/router';

import * as React from 'react';
import { Helmet } from 'react-helmet';

interface IOwnProps {
  collection: GQL.ICollection;
}

type CollectionHelmetProps = IOwnProps;

const defaultList = [];

export default function CollectionHelmet(props: CollectionHelmetProps) {
  const {
    collection: {
      assets,
      description,
      name,
    },
  } = props;

  const title = `Collection ${name}`;
  const coverAssets = getResponsiveAssets('cover', assets || defaultList);
  const image = coverAssets.xlarge && coverAssets.xlarge.find(({ format }) => format !== 'webp');
  const imageHasMetadata = !!image && !!image.metadata;

  return (
    <Helmet>
      <title>{title}</title>
      {!!description && <meta name="description" property="og:description" content={description} />}
      <meta property="og:determiner" content="a" />
      <meta property="og:title" content={title} />
      {image && [
        <meta key="og:image" property="og:image" content={`${getOriginLocation()}${image!.path}`} />,
        <meta key="og:image:type" property="og:image:type" content="image/jpeg" />,
        imageHasMetadata && [
          <meta key="og:image:width" property="og:image:width" content={image!.metadata.width.toString()} />,
          <meta key="og:image:width" property="og:image:height" content={image!.metadata.height.toString()} />,
        ],
        <meta
          key="og:image:alt"
          property="og:image:alt"
          content={`Collection ${name} image on ${tr.pageTitles.default}`}
        />,
      ]}
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Collection/helmet.tsx